"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var RowDelete_exports = {};
__export(RowDelete_exports, {
  default: () => RowDelete_default
});
module.exports = __toCommonJS(RowDelete_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.00002 3.5C6.00002 3.22386 6.22388 3 6.50002 3H12.5C12.7762 3 13 3.22386 13 3.5V7.5C13 7.77614 12.7762 8 12.5 8H6.50002C6.22388 8 6.00002 7.77614 6.00002 7.5V3.5ZM7.00002 4V7H12V4H7.00002ZM14 3.5C14 3.22386 14.2239 3 14.5 3H20.5C20.7762 3 21 3.22386 21 3.5V7.5C21 7.77614 20.7762 8 20.5 8H14.5C14.2239 8 14 7.77614 14 7.5V3.5ZM15 4V7H20V4H15ZM6.00002 16.5C6.00002 16.2239 6.22388 16 6.50002 16H12.5C12.7762 16 13 16.2239 13 16.5V20.5C13 20.7761 12.7762 21 12.5 21H6.50002C6.22388 21 6.00002 20.7761 6.00002 20.5V16.5ZM14 16.5C14 16.2239 14.2239 16 14.5 16H20.5C20.7762 16 21 16.2239 21 16.5V20.5C21 20.7761 20.7762 21 20.5 21H14.5C14.2239 21 14 20.7761 14 20.5V16.5ZM3.58672 12.8184C3.39126 13.0139 3.39093 13.3305 3.586 13.5255C3.78106 13.7206 4.09764 13.7203 4.2931 13.5248L4.99151 12.8264L5.70413 13.539C5.89919 13.7341 6.21577 13.7338 6.41123 13.5383C6.60669 13.3428 6.60702 13.0262 6.41196 12.8312L5.69935 12.1186L6.40906 11.4089C6.60452 11.2134 6.60484 10.8968 6.40978 10.7018C6.21472 10.5067 5.89814 10.507 5.70268 10.7025L4.99296 11.4122L4.30034 10.7196C4.10528 10.5245 3.78869 10.5248 3.59323 10.7203C3.39777 10.9158 3.39745 11.2323 3.59251 11.4274L4.28513 12.12L3.58672 12.8184ZM20.5 12.5C20.7761 12.5 21 12.2761 21 12C21 11.7239 20.7761 11.5 20.5 11.5L7.49999 11.5C7.22385 11.5 6.99999 11.7239 6.99999 12C6.99999 12.2761 7.22385 12.5 7.49999 12.5L20.5 12.5Z",
      fill: "currentColor"
    }
  )
);
const SvgRowDelete = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var RowDelete_default = SvgRowDelete;
